import HeroGrid from "./HeroGrid";

export default HeroGrid;
